export const getCaseGranulometryEditSuperstructureTriggerId = (caseLabel: string) =>
  `case${caseLabel}EditSuperstructureTrigger`;
